import Axios from '../utils/axios-utils';


// get dashboard fleet
export const getAllDashboardFleet = async (accountId, from) => {
    try {
        const response = await Axios.get(`/accounts/${accountId}/dashboard/fleet`, {
            params: { from },
        });

        return {
            success: response.data.status === 'success',
            data: response.data,
        };
    } catch (error) {
        console.log("Get All Dashboard fleet error:", error);
        return {
            success: false,
            data: error.response?.data || { message: "Get All Dashboard fleet failed" }
        };
    }
};


// get dashboard Crew
export const getAllDashboardCrew = async (accountId, from) => {
    try {
        const response = await Axios.get(`/accounts/${accountId}/dashboard/crew`, {
            params: { from },
        });

        return {
            success: response.data.status === 'success',
            data: response.data,
        };
    } catch (error) {
        console.log("Get All Dashboard Crew error:", error);
        return {
            success: false,
            data: error.response?.data || { message: "Get All Dashboard Crew failed" }
        };
    }
};